const slider = () => {
    // Slider

    const slides = document.querySelectorAll('.offer__slide'),
        slider = document.querySelector('.offer__slider'),
        prev = document.querySelector('.offer__slider-prev'),
        next = document.querySelector('.offer__slider-next'),
        total = document.querySelector('#total'),
        current = document.querySelector('#current'),
        slidesWrapper = document.querySelector('.offer__slider-wrapper'),
        slidesField = document.querySelector('.offer__slider-inner'),
        width = window.getComputedStyle(slidesWrapper).width;
    let slideIndex = 1,
        offset = 0,
        dots = [];

    if (slides.length < 10){
        total.textContent = `0${slides.length}`;
        current.textContent = `0${slideIndex}`;
    } else {
        total.textContent = slides.length;
        current.textContent = slideIndex;
    }


    slidesField.style.width = 100 * slides.length + '%';
    slidesField.style.display = 'flex';
    slidesField.style.transition = '0.5s all';

    slidesWrapper.style.overflow = 'hidden';

    slides.forEach(slide => {
        slide.style.width = width
    })

    slider.style.position = 'relative';

    // Створення блоку з індикаторами слайдера
    const indicators = document.createElement('ol');
    indicators.classList.add('carousel-indicators')
    indicators.style.cssText = `
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 15;
        display: flex;
        justify-content: center;
        margin-right: 15%;
        margin-left: 15%;
        list-style: none;
    `
    slider.append(indicators);

    // Створення індмкаторів для слайдера у кількості рівної до кількості слайдів
    for (let i = 0; i < slides.length; i++){
        const dot = document.createElement('li');
        dot.classList.add('dot');
        dot.style.cssText = `
            box-sizing: content-box;
            flex: 0 1 auto;
            width: 30px;
            height: 6px;
            margin-right: 3px;
            margin-left: 3px;
            cursor: pointer;
            background-color: #fff;
            background-clip: padding-box;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            opacity: .5;
            transition: opacity .6s ease;
        `
        // dot.createAttribute('[data-slide-to]') = `sddss`
        indicators.append(dot);
        dots.push(dot);

        if(i === 0){
            dot.style.opacity = '1';
        }
    }

    next.addEventListener('click', () => {
        if (offset === +width.slice(0, width.length - 2)* (slides.length - 1)){
            offset = 0;
        } else {
            offset += +width.slice(0, width.length - 2);
        }
        // Перемістити на 1 слайд
        slidesField.style.transform = `translateX(-${offset}px)`

        // Перейти до першого слайду, якщо слайди закінчились
        if (slideIndex === slides.length){
            slideIndex = 1
        } else {
            slideIndex++;
        }

        // Контроль нуля у поточному числі слайдів
        if (slideIndex < 10){
            current.textContent = `0${slideIndex}`
        } else {
            current.textContent = slideIndex
        }

        // Змінити активний індикатор
        dots.forEach(dot => dot.style.opacity = '0.5');
        dots[slideIndex - 1].style.opacity = '1';
    })

    prev.addEventListener('click', () => {
        if (offset === 0){
            offset = +width.slice(0, width.length - 2)* (slides.length - 1);
        } else {
            offset -= +width.slice(0, width.length - 2)
        }
        // Перемістити на 1 слайд
        slidesField.style.transform = `translateX(-${offset}px)`

        // Перейти до першого слайду, якщо слайди закінчились
        if (slideIndex === 1){
            slideIndex = slides.length;
        } else {
            slideIndex--;
        }

        // Контроль нуля у поточному числі слайдів
        if (slideIndex < 10){
            current.textContent = `0${slideIndex}`
        } else {
            current.textContent = slideIndex
        }

        // Змінити активний індикатор
        dots.forEach(dot => dot.style.opacity = '0.5');
        dots[slideIndex - 1].style.opacity = '1';
    })

    dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
            // Змінити індекс слайда на натиснутий слайд
            slideIndex = dotIndex + 1;

            // Змістити карусель до потрібного слайда
            offset = +width.slice(0, width.length - 2) * dotIndex;
            slidesField.style.transform = `translateX(-${offset}px)`

            // Змінити активний індикатор
            dots.forEach(dot => dot.style.opacity = '0.5');
            dots[dotIndex].style.opacity = '1';

            // Контроль нуля у поточному числі слайдів
            if (slideIndex < 10){
                current.textContent = `0${slideIndex}`
            } else {
                current.textContent = slideIndex;
            }
        })
    })
}
export default slider;